import sdl from '@jds/react-generated-sdl/JDSDatepickerHeader';
import type { JDSDatepickerHeaderProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSDatepickerHeaderProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    state = 'default',
    showArrows = true,
    monthSelectable = true,
    yearSelectable = true,
    previousAriaLabel = 'Navigate to previous month',
    nextAriaLabel = 'Navigate to next month',
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    {
      state,
      showArrows,
      monthSelectable,
      yearSelectable,
      previousAriaLabel,
      nextAriaLabel,
      ...rest
    },
    'JDSDatepickerHeader',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const DatepickerHeader = withLogic(
  Component
) as React.FC<JDSDatepickerHeaderProps> & { slotName?: string };

DatepickerHeader.displayName = 'DatepickerHeader';
DatepickerHeader.slotName = 'jds_datepicker_header';

export { DatepickerHeader, type JDSDatepickerHeaderProps };
